// extracted by mini-css-extract-plugin
export default {"wrapper":"Dropdown_wrapper__PksGg","paragraph":"Dropdown_paragraph__Kxi5W"};